import styled from "styled-components"

import checkboxSvg from "assets/svg/checkbox-new.svg"

export const RoleHeader = styled.div`
  font-size: 14px;
`

export const RoleContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  border-bottom: 1px solid #e2e8f0;
  padding: 10px 0;

  &:last-child {
    border-bottom: none;
  }

  > div:last-child {
    flex: 0 0 25px;
    align-self: center;
  }

  > div:first-child {
    flex: 1;
  }

  & .radioButtonWrapper {
    & label.radioLabel {
      display: flex;
      border-radius: 12px;
      position: relative;
      display: flex;
      justify-content: space-between;
      cursor: pointer;

      &::before {
        display: flex;
        width: 18px;
        height: 18px;
        border: 1px solid #bfc6cd;
        border-radius: 50%;
        overflow: hidden;
        content: "";
      }

      & input {
        position: absolute;
        right: 0;
        top: 0;
        display: none;
      }
    }

    div {
      padding: 0;
    }

    & label.radioLabelChecked {
      &::before {
        border: transparent;
        background-image: url("${checkboxSvg}");
        background-size: 47px;
        background-position: -3px;
      }
    }
  }
`

export const RoleTitle = styled.div`
  font-size: 14px;
`

export const RoleDescription = styled.div`
  font-size: 12px;
  font-weight: 300;
  margin-top: 2px;
`
